import { render } from "./CoursePdf.vue?vue&type=template&id=7423baaa&scoped=true"
import script from "./CoursePdf.vue?vue&type=script&lang=js"
export * from "./CoursePdf.vue?vue&type=script&lang=js"

import "./CoursePdf.vue?vue&type=style&index=0&id=7423baaa&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7423baaa"]])

export default __exports__